// extracted by mini-css-extract-plugin
export var caretAnchor = "_ux-0";
export var dropdownContent = "_ux-1";